import React, { useState } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { Navigate, useNavigate } from 'react-router';

import {
  getClientUrls,
  hasApiSessionsPermission,
  isUserLoggedIn,
  upgradePlanColorGradient,
} from '@paragon/login-tools';
import { ApiKeysDialog } from '@paragon/themes/source/components/ApiKeysDialog';

import apiIcon from '../../resources/API.png';
import assemblyIcon from '../../resources/assembly.png';
import designIcon from '../../resources/design.png';
import layoutIcon from '../../resources/layout.png';
import markupIcon from '../../resources/markup.png';
import projectsIcon from '../../resources/projects.png';
import { useAppSelector } from './hooks';
import { ServicesPage } from './ServicesPage';

const buttonSx = { mt: 2, width: '100%' };

export function Home() {
  const loggedInUser = useAppSelector((state) => isUserLoggedIn(state));
  const designUrl = useAppSelector(getClientUrls).designUrl;
  const hasApiPermission = useAppSelector(hasApiSessionsPermission);

  const navigate = useNavigate();

  const [showApiKeysDialog, setShowApiKeysDialog] = useState(false);

  if (!loggedInUser) return <Navigate to="/login" replace />;

  return (
    <ServicesPage>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100%',
          padding: 3,
          minWidth: 0, // So the Typography noWrap works
        }}
      >
        <Typography align="center" variant="h1" color="secondary" sx={{ mt: 4, mb: 12, fontSize: '3em' }}>
          Welcome to Paragon!
        </Typography>
        <Grid container direction="row" spacing={2} sx={{ justifyContent: 'space-evenly', alignItems: 'start', mt: 4 }}>
          <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography align="center" variant="h5">
              DESIGN
            </Typography>
            <Box
              component="img"
              sx={{
                width: 100,
                mt: 2,
              }}
              alt="Paragon"
              src={designIcon}
              onClick={() => window.open(designUrl, '_blank')}
            />
            <Button
              variant="contained"
              color="secondary"
              onClick={() => window.open(designUrl, '_blank')}
              sx={buttonSx}
            >
              Get Started
            </Button>
          </Grid>
          <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography align="center" variant="h5">
              LAYOUT
            </Typography>
            <Box
              component="img"
              sx={{
                width: 100,
                mt: 2,
              }}
              alt="Paragon"
              src={layoutIcon}
            />
            <Button disabled variant="text" color="primary" sx={{ mt: 2 }}>
              Coming Soon
            </Button>
          </Grid>
          <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography align="center" variant="h5">
              ASSEMBLY
            </Typography>
            <Box
              component="img"
              sx={{
                width: 100,
                mt: 2,
              }}
              alt="Paragon"
              src={assemblyIcon}
            />
            <Button disabled variant="text" color="primary" sx={{ mt: 2 }}>
              Coming Soon
            </Button>
          </Grid>
          <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography align="center" variant="h5">
              PROJECTS
            </Typography>
            <Box
              component="img"
              sx={{
                width: 100,
                mt: 2,
              }}
              alt="Paragon"
              src={projectsIcon}
            />
            <Button disabled variant="text" color="primary" sx={{ mt: 2 }}>
              Coming Soon
            </Button>
          </Grid>
          <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography align="center" variant="h5">
              MARKUP
            </Typography>
            <Box
              component="img"
              sx={{
                width: 100,
                mt: 2,
              }}
              alt="Paragon"
              src={markupIcon}
            />
            <Button disabled variant="text" color="primary" sx={{ mt: 2 }}>
              Coming Soon
            </Button>
          </Grid>
          <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography align="center" variant="h5">
              API
            </Typography>
            <Box
              component="img"
              sx={{
                width: 100,
                mt: 2,
              }}
              alt="Paragon"
              src={apiIcon}
            />
            {hasApiPermission ? (
              <Button
                variant="contained"
                color="secondary"
                onClick={() => void setShowApiKeysDialog(true)}
                sx={buttonSx}
              >
                API Keys
              </Button>
            ) : (
              <Button
                variant="contained"
                sx={{ ...buttonSx, background: upgradePlanColorGradient }}
                onClick={() => navigate('/account')}
              >
                Upgrade
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              onClick={() => window.open('https://www.paragontruss.com/api', '_blank')}
              sx={buttonSx}
            >
              Info
            </Button>
          </Grid>
        </Grid>
      </Box>

      {showApiKeysDialog && <ApiKeysDialog onClose={() => void setShowApiKeysDialog(false)} />}
    </ServicesPage>
  );
}
